// 全局过滤器

export default {
    /**
     * 时间戳转换成日期
     * @param time 时间戳（单位：秒）
     * @returns {*} 格式化后日期
     */
    prettyDate: function (time) {
        // 日期
        var date = new Date(time);
        // 年
        var y = date.getFullYear();
        // 月
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        // 日
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;

        // 年-月-日
        return y + '-' + m + '-' + d;
    },
    /**
     * 时间戳转换成日期时间
     * @param time 时间戳（单位：秒）
     * @returns {*} 格式化后日期时间
     */
    prettyDateTime: function (time) {
        // 日期
        var date = new Date(time);
        // 年
        var y = date.getFullYear();
        // 月
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        // 日
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        // 时
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        // 分
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        // 秒
        var second = date.getSeconds();
        second = second < 10 ? ('0' + second) : second;

        // 年-月-日 时:分:秒
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    },
    /**
     * 时间秒数格式化
     * @param s 时间戳（单位：秒）
     * @returns {*} 格式化后的时分秒
     */
    secToTime: function (s) {
        var t = '';
        if (s > -1) {
            var hour = Math.floor(s / 3600);
            var min = Math.floor(s / 60) % 60;
            var sec = s % 60;

            if (hour > 10) {
                t = hour + ":";
            } else {
                t = '0' + hour + ":";
            }

            if (min < 10) {
                t += "0";
            }
            t += min + ":";
            if (sec < 10) {
                t += "0";
            }
            t += sec;
        }

        return t;
    },
    /**
     * 时间秒数格式化2 不显示小时
     * @param s 时间戳（单位：秒）
     * @returns {*} 格式化后的分秒
     */
    secToTime2: function (s) {
        var t = '';
        if (s > -1) {
            var min = Math.floor(s / 60);
            var sec = s % 60;

            if (min < 10) {
                t += "0";
            }
            t += min + ":";
            if (sec < 10) {
                t += "0";
            }
            t += sec;
        }

        return t;
    },
    /**
     * 时间转换成秒数
     * @param time hh:mm:ss|h:m:s 或 mm:ss|m:s
     * @returns {number}
     */
    timeToSec: function (time) {
        time = time.split(':');
        if (time.length == 3) {// hh:mm:ss|h:m:s
            let [hour, minute, second] = time;

            return 3600 * parseInt(hour) + 60 * parseInt(minute) + parseInt(second);
        } else if (time.length == 2) {// mm:ss|m:s
            let [minute, second] = time;

            return 60 * parseInt(minute) + parseInt(second);
        }
    },
    /**
     * 阿拉伯数字转中文数字
     * @param num
     * @returns {string}
     */
    numberToChinese: function (num) {
        var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
        var chnUnitChar = ["", "十", "百", "千", "万", "十", "百", "千", "亿"];
        var strIns = '', chnStr = '';
        var unitPos = 0;
        var zero = true;
        while (num > 0) {
            var v = num % 10;
            if (v === 0) {
                if (!zero) {
                    zero = true;
                    chnStr = chnNumChar[v] + chnStr;
                }
            } else {
                zero = false;
                strIns = chnNumChar[v];
                strIns += chnUnitChar[unitPos];
                chnStr = strIns + chnStr;
            }
            unitPos++;
            num = Math.floor(num / 10);
        }

        return chnStr;
    },

    /**
     * 格式化文件大小
     * @returns {*}
     */
    renderSize: function (value) {
        if (null == value || value == '') {
            return "0 Bytes";
        }
        var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
        var index = 0,
            srcsize = parseFloat(value);
        index = Math.floor(Math.log(srcsize) / Math.log(1024));
        var size = srcsize / Math.pow(1024, index);
        //  保留的小数位数
        size = size.toFixed(2);
        return size + unitArr[index];
    },

    /**
     * 保留两位小数
     * @returns {*}
     */
    toPrice: function (price) {
        var f_x = parseFloat(price);
        if (isNaN(f_x)) {
            return 0;
        }
        var f_x = Math.round(price * 100) / 100;
        var s_x = f_x.toString();
        var pos_decimal = s_x.indexOf('.');
        if (pos_decimal < 0) {
            pos_decimal = s_x.length;
            s_x += '.';
        }
        while (s_x.length <= pos_decimal + 2) {
            s_x += '0';
        }
        return s_x;

    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js